import React from 'react';
import type { PropertyAnalysisResult } from '../../types/calculations';
import { SectionTitle } from '../Luxury';
import { Clock, TrendingUp } from 'lucide-react';

interface Props {
  data: PropertyAnalysisResult;
}

export const HoldPeriodSelector: React.FC<Props> = ({ data }) => {
  const holdPeriod = data.investment_intelligence?.offer_intelligence?.hold_period;

  if (!holdPeriod) {
    return null;
  }

  return (
    <div className="bg-charcoal rounded-xl border border-slate-dark p-6">
      <SectionTitle icon={<Clock className="w-5 h-5" />}>Recommended Hold Period</SectionTitle>

      <div className="flex items-start gap-6">
        {/* Hold period badge */}
        <div className="flex-shrink-0">
          <div className="w-20 h-20 rounded-xl bg-gradient-to-br from-purple-600/30 to-purple-900/30 border-2 border-purple-500/50 flex flex-col items-center justify-center">
            <span className="text-3xl font-bold font-mono text-purple-300">{holdPeriod.recommended_years}</span>
            <span className="text-sm text-purple-400 uppercase tracking-wider">Years</span>
          </div>
        </div>

        {/* Details */}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-3 mb-2">
            <TrendingUp className="w-4 h-4 text-emerald-400" />
            <span className="text-sm font-semibold text-stone-300">
              CAGR Bracket: <span className="font-mono text-emerald-400">{holdPeriod.cagr_bracket}</span>
            </span>
          </div>
          <p className="text-sm text-stone-700 leading-relaxed">
            {holdPeriod.rationale}
          </p>
        </div>
      </div>
    </div>
  );
};
